/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tab_RegisteringInputs */

const th_tab_registering = /** @type {(inputs: Tab_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปิดรับสมัคร`)
};

const en_tab_registering = /** @type {(inputs: Tab_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registering`)
};

const ja_tab_registering = /** @type {(inputs: Tab_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`受付中`)
};

const zh_tab_registering = /** @type {(inputs: Tab_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`报名中`)
};

const es_tab_registering = /** @type {(inputs: Tab_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscripción abierta`)
};

const pt_tab_registering = /** @type {(inputs: Tab_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscrições abertas`)
};

const id_tab_registering = /** @type {(inputs: Tab_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pendaftaran dibuka`)
};

const fr_tab_registering = /** @type {(inputs: Tab_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscriptions ouvertes`)
};

const tl_tab_registering = /** @type {(inputs: Tab_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bukas ang rehistrasyon`)
};

const vi_tab_registering = /** @type {(inputs: Tab_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang mở đăng ký`)
};

const ko_tab_registering = /** @type {(inputs: Tab_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`등록 중`)
};

const de_tab_registering = /** @type {(inputs: Tab_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meldung läuft`)
};

const ru_tab_registering = /** @type {(inputs: Tab_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Идёт заявка`)
};

const tr_tab_registering = /** @type {(inputs: Tab_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kayıt açık`)
};

const it_tab_registering = /** @type {(inputs: Tab_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iscrizioni aperte`)
};

const pl_tab_registering = /** @type {(inputs: Tab_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trwają zgłoszenia`)
};

const uk_tab_registering = /** @type {(inputs: Tab_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Триває заявка`)
};

const hi_tab_registering = /** @type {(inputs: Tab_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पंजीकरण चालू`)
};

const ar_tab_registering = /** @type {(inputs: Tab_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التسجيل مفتوح`)
};

const ms_tab_registering = /** @type {(inputs: Tab_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pendaftaran dibuka`)
};

const bn_tab_registering = /** @type {(inputs: Tab_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নিবন্ধন চলছে`)
};

const zh_tw2_tab_registering = /** @type {(inputs: Tab_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`報名中`)
};

const zh_hk2_tab_registering = /** @type {(inputs: Tab_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`報名中`)
};

const ur_tab_registering = /** @type {(inputs: Tab_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رجسٹریشن جاری`)
};

const fa_tab_registering = /** @type {(inputs: Tab_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ثبت‌نام باز`)
};

const sw_tab_registering = /** @type {(inputs: Tab_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usajili unaendelea`)
};

const nl_tab_registering = /** @type {(inputs: Tab_RegisteringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inschrijving open`)
};

/**
* | output |
* | --- |
* | "Registering" |
*
* @param {Tab_RegisteringInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const tab_registering = /** @type {((inputs?: Tab_RegisteringInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tab_RegisteringInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_tab_registering(inputs)
	if (locale === "ja") return ja_tab_registering(inputs)
	if (locale === "zh") return zh_tab_registering(inputs)
	if (locale === "es") return es_tab_registering(inputs)
	if (locale === "pt") return pt_tab_registering(inputs)
	if (locale === "id") return id_tab_registering(inputs)
	if (locale === "fr") return fr_tab_registering(inputs)
	if (locale === "tl") return tl_tab_registering(inputs)
	if (locale === "vi") return vi_tab_registering(inputs)
	if (locale === "ko") return ko_tab_registering(inputs)
	if (locale === "de") return de_tab_registering(inputs)
	if (locale === "ru") return ru_tab_registering(inputs)
	if (locale === "tr") return tr_tab_registering(inputs)
	if (locale === "it") return it_tab_registering(inputs)
	if (locale === "pl") return pl_tab_registering(inputs)
	if (locale === "uk") return uk_tab_registering(inputs)
	if (locale === "hi") return hi_tab_registering(inputs)
	if (locale === "ar") return ar_tab_registering(inputs)
	if (locale === "ms") return ms_tab_registering(inputs)
	if (locale === "bn") return bn_tab_registering(inputs)
	if (locale === "zh-TW") return zh_tw2_tab_registering(inputs)
	if (locale === "zh-HK") return zh_hk2_tab_registering(inputs)
	if (locale === "ur") return ur_tab_registering(inputs)
	if (locale === "fa") return fa_tab_registering(inputs)
	if (locale === "sw") return sw_tab_registering(inputs)
	if (locale === "nl") return nl_tab_registering(inputs)
	return en_tab_registering(inputs)
});